export default __webpack_public_path__ + "static/media/03.b84e3b42.jpg";